import React from 'react'
import {JsonEditor as Editor} from 'jsoneditor-react';
import 'jsoneditor-react/es/editor.min.css';

export default function JSONEditor(props) {
  const handleChange = data => {
    //do some fs stuff/ ping backend here
    let temp = props.controller.getContentData();
    temp.steps[props.controller.getStepIndex()] = data;
    props.controller.setContentData(temp)
    props.controller.forceRender();
  }
  return (
    <Editor
      value={props.controller.getCurrentStepData()}
      onChange={(a) => handleChange(a)}
    />
  )
}
